import useCart from '@/contexts/useCart'
import React, { useMemo } from 'react'
import EmptyCartState from '../app/empty-cart-state'
import CartExpireTimer from '../app/cart-expire-timer'
import CheckoutItem from './checkout-item'
import { Separator } from '../ui/separator'
import { Button } from '../ui/button'
import { formatPrice } from '@/helper/formatter'
import { shouldHideFreeLabel } from '@/helper/utils'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const CartContent = ({ checkoutUrl }: { checkoutUrl: string }) => {
  const { t } = useTranslation('experience')
  const { masterOrder, totalAmount } = useCart()

  const router = useRouter()

  const handleCheckout = () => {
    router.push(checkoutUrl)
  }

  const allHideFreeLabel = useMemo(() => {
    const allPrices = masterOrder?.orders?.flatMap(
      (order) => order.option?.prices ?? []
    ) ?? []
    return shouldHideFreeLabel(allPrices)
  }, [masterOrder?.orders])

  const hideTotalRow = totalAmount < 0.01 && allHideFreeLabel

  return (
    <div className="flex-1 flex flex-col min-h-0">
      {!masterOrder?.orders?.length ? (
        <EmptyCartState />
      ) : (
        <>
          {/* 主要内容区域 - 可滚动 */}
          <div className="flex-1 overflow-y-auto min-h-0 pb-4">
            <div className="space-y-4 mt-4">
              <CartExpireTimer />

              {masterOrder?.orders?.map((order) => (
                <CheckoutItem order={order} key={order.id} removable />
              ))}
            </div>
          </div>

          {/* 底部固定区域 - 总价和结账按钮 */}
          <div className="pt-4 mt-auto bg-background">
            <Separator className="mb-4" />
            {!hideTotalRow && (
              <div className="mb-4 flex justify-between items-center">
                <strong className="font-semibold text-lg">
                  {t('total_price')}
                </strong>
                <span>
                  {masterOrder.orders.length > 0 && totalAmount < 0.01
                    ? t('common:free')
                    : formatPrice(totalAmount)}
                </span>
              </div>
            )}
            <Button className="w-full uppercase" onClick={handleCheckout}>
              {totalAmount < 0.01
                ? t('common:book')
                : t('common:proceed_to_payment')}
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default CartContent
